import React, { use, useEffect, useState } from "react";
import { Avatar, Box, Button, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "antd";
import LoginPageLogo from "../../assets/images/LoginPageLogo.png";
import { Padding } from "@mui/icons-material";
import Styles from "./FeedbackForm.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getProjectByToken,
  updateProjectResponse,
} from "../../services/feedbackForm.service";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import { ColorRing } from "react-loader-spinner";

const FormMain = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [token, setToken] = useState(null);
  const [data, setData] = useState([]);
  const [tableCount, setTableCount] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tokenFromUrl = queryParams.get("token");
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
  }, [location.search]);

  const GetProjectByTokenData = async () => {
    setOpenLoader(true);
    try {
      if (token) {
        const res = await getProjectByToken({ token });
        const modifiedData = {
          ...res?.data,
          contactName: res?.data?.contact?.name,
        };
        setTableCount(res?.totalCount || 0);
        setData(modifiedData);
        // setOpenLoader(false);
      } else {
        console.log("Token is missing.");
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      setOpenLoader(false);
    }
  };
  const deleteFunction = () => {
    navigate("/feedbackNeverAsk", { state: data });
  };
  useEffect(() => {
    GetProjectByTokenData();
  }, [token]);

  // const handleNeverAskAgain = async () => {
  //   setOpenDrawer(false);
  //   try {
  //     const feedbackData = {
  //       upComingSurveyDate: null,
  //       surveyInterval: null,
  //     };
  //     const res = await updateProjectResponse(data?.transId, feedbackData);

  //     console.log(res, "res");
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  console.log("data: ", data)
  return (
    <>
      {/* {openLoader ? (
        <div style={{ textAlign: "center", width: "100%" }}>
          <ColorRing
            visible={true}
            height="60"
            width="60"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={["#00675D", "#00675D", "#00675D", "#00675D", "#00675D"]}
          />
        </div> */}
      {/*  ) : ( */}
      <Box>
        {/* Header */}
        <Box className={Styles.Container}>
          <Typography
            style={{
              color: "white",
              fontSize: "24px",
              fontWeight: 700,
              marginLeft: "3%",
            }}
          >
            WSH
          </Typography>
          <Stack
            direction={"row"}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              mr: "1%",
            }}
          >
            <Box
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* Avatar component */}
              <Avatar
                sx={{
                  height: "40px",
                  // width: "40px",
                  background: "white",
                  color: "#00675d",
                  paddingLeft: "10px", // Add space for the text
                  paddingRight: "10px",
                  marginRight: "-5px", // Negative margin to move Box to the right
                  zIndex: 1, // Ensure Avatar is on top
                }}
              >
                {data?.contactName?.charAt(0)}
              </Avatar>
              {/* Box component */}
              <Box
                sx={{
                  background: "#FFFFFF33",
                  borderRadius: 5,
                  height: "40px",
                  width: "200px",
                  maxWidth: "150px",
                  color: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  marginLeft: "-13%",
                  zIndex: 2,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <Typography style={{ paddingLeft: "7%", color: "white" }}>
                  {data?.contactName?.length > 10
                    ? `${data?.contactName?.slice(0, 10)}...`
                    : data?.contactName}
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Box>

        {data?.isAns == true ||
        data?.isSkippedFull == true ||
        data?.isSkippedNow == true ? (
          <Stack className={Styles.Content}>
            <img
              src={LoginPageLogo}
              alt="Company Logo"
              style={{ width: 147 }}
            />
            <Typography className={Styles.Welcome}>
              {/* Welcome {data?.contactName}! */}
            </Typography>
            <Typography style={{ fontWeight: 500, fontSize: "22px" }}>
              Feedback{" "}
              {data?.isAns == true
                ? " Already Submmitted"
                : data?.isSkippedFull == true
                ? "Skipped Fully"
                : data?.isSkippedNow == true
                ? "Skipped Now"
                : ""}
            </Typography>

            <Typography
              style={{
                fontWeight: 400,
                fontSize: "18px",
                alignItems: "center",
                color: "#000000",
                padding: "0px 20px",
              }}
            >
              {data?.isAns === true ? (
                <>
                  You've already shared your valuable feedback for the project{" "}
                  {/* <strong>Workforce Solutions for {data?.projectName}</strong> */}
                  <br />
                  Looking forward to continuing our partnership!
                </>
              ) : data?.isSkippedFull === true ? (
                <>
                  You have skipped this. To get the form link again, you need to
                  update your information
                </>
              ) : data?.isSkippedNow === true ? (
                <>
                  You cannot fill this again. If you have any concerns, feel
                  free to reach out
                </>
              ) : (
                ""
              )}
            </Typography>
          </Stack>
        ) : (
          data?.isAns === false &&
          data?.isSkippedFull === false &&
          data?.isSkippedNow === false
        ) ? (
          <>
            {/* Content */}
            <Stack className={Styles.Content}>
              <img
                src={LoginPageLogo}
                alt="Company Logo"
                style={{ width: 140 }}
              />
              <Typography className={Styles.Welcome}>
                Welcome {data?.contactName}!
              </Typography>
              {/* <Typography className={Styles.CompanyTitle}>
                Workforce Solutions for {data?.projectName}
              </Typography> */}
              <Typography
                style={{
                  marginTop: 25,
                  fontWeight: 400,
                  fontSize: "16px",
                  alignItems: "center",
                  color: "#000000",
                }}
              >
                Thank you for being a valued partner.
              </Typography>
              <Typography
                style={{
                  fontWeight: 400,
                  fontSize: "16px",
                  alignItems: "center",
                  color: "#000000",
                  padding: "0px 20px",
                }}
              >
                Your feedback helps us improve our services and better
                understand your needs. We will
                <br />
                share this survey every 3 months to ensure we deliver the best
                possible experience.
              </Typography>

              <Typography
                style={{
                  marginTop: 30,
                  fontWeight: 400,
                  fontSize: "16px",
                  alignItems: "center",
                  color: "#000000",
                  padding: "0px 20px",
                }}
              >
                This survey will take only a few minutes of your time.
              </Typography>
            </Stack>

            {/* Buttons */}
            <Stack direction="row" spacing={2} className={Styles.buttonContent}>
              <Button
                className={Styles.primaryButton}
                onClick={() => navigate("/clientFeedbackForm", { state: data })}
              >
                Take Survey
              </Button>
              {/* <Button
                className={Styles.secondaryButton}
                onClick={() => navigate("/feedbackSkip", { state: data })}
              >
                Skip Now
              </Button>
              <Button
                className={Styles.secondaryButton}
                onClick={() => navigate("/feedbackNeverAsk", { state: data })}
                // onClick={handleNeverAskAgain}
              >
                Never Ask Again
              </Button> */}
            </Stack>
          </>
        ) : (
          <div className={Styles.Content}>
          <ColorRing
            visible={true}
            height="60"
            width="60"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={["#00675D", "#00675D", "#00675D", "#00675D", "#00675D"]}
          />
        </div>
        )}
      </Box>
      {/*  )} */}
      {openDrawer && (
        <ConfirmBox
          open={openDrawer}
          title="Confirm"
          content="Are you sure you want to never be asked again?"
          confirmButton="Confirm"
          setOpenConfirmBox={() => setOpenDrawer(false)}
          Function={deleteFunction}
        />
      )}
    </>
  );
};

export default FormMain;
